import { render } from "./UpdateSignedCertificate.vue?vue&type=template&id=62343266&scoped=true"
import script from "./UpdateSignedCertificate.vue?vue&type=script&lang=js"
export * from "./UpdateSignedCertificate.vue?vue&type=script&lang=js"

import "./UpdateSignedCertificate.vue?vue&type=style&index=0&id=62343266&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62343266"]])

export default __exports__